/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetTransportsBrandsQueryParams,
  GetTransportsBrands200,
  GetTransportsBrands400,
  GetTransportsBrandsQueryResponse,
} from '../entities/GetTransportsBrands'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetTransportBrandsResponseSchema } from './v1/getTransportBrandsResponseSchema'
import { z } from 'zod'

export const getTransportsBrandsQueryParamsSchema = z
  .object({
    search: z.string().describe('Search').optional(),
  })
  .optional() as unknown as ToZod<GetTransportsBrandsQueryParams>

/**
 * @description OK
 */
export const getTransportsBrands200Schema = z.lazy(() => v1GetTransportBrandsResponseSchema) as unknown as ToZod<GetTransportsBrands200>

/**
 * @description Bad Request
 */
export const getTransportsBrands400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetTransportsBrands400>

export const getTransportsBrandsQueryResponseSchema = z.lazy(() => getTransportsBrands200Schema) as unknown as ToZod<GetTransportsBrandsQueryResponse>